module.exports = __webpack_public_path__ + "img/ico_pickup_today.69af1e3.svg";